export const IdsDosBotoesDeConversaoDoLeadsCenter = {
  hero: 1,
  header: 4,
  footer: 5,
  menu: 6,
  modal: 11,
}
